<template class="client-payment-form">
<div class="client-payment-form">
  <div class="full-width">
    <div class="row-space-between small-top">
      <span>Total Due Now:</span>
      <span>${{price}}</span>
    </div>
    <div class="row-space-between small-top"><span>This Will Be Billed Monthly At:</span>
      <span v-if="offering.price">${{price}}</span>
      <span v-else>$0</span>
    </div>
    <div class="cancel">*Cancel Any Time</div>
  </div>
  <form id="payment-form" class="small-top full-width">
    <div class="form-row small-top">
      <div id="card-element">
        <!-- A Stripe Element will be inserted here. -->
      </div>
  
      <!-- Used to display Element errors. -->
      <div id="card-errors" role="alert"></div>
    </div>
    <v-alert type="error" :value="error">{{error}}</v-alert>
    <v-alert type="error" :value="serverError">{{serverError}}</v-alert>

    <h-btn style="width: 100%" :disabled="disabled" type="button" class="small-top full-width" color="primary" @click="finish">Finish</h-btn>
  </form>
</div>
</template>

<script>
export default {
  props: ['offering', 'serverError', 'disabled'],
  data() {
    return {
      error: ""
    };
  },
  computed: {
    price() {
      return Number(this.offering.price_in_dollars).toFixed(2).toLocaleString()
    }
  },
  created() {
    setTimeout(() => {
      const stripe = Stripe(this.offering.stripe_key);
      this.stripe = stripe;
      const elemn = stripe.elements();
      const style = {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
         }
      };
      const card = elemn.create('card', {style});
      card.mount('#card-element');
      card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = "";
        }
      });
      this.card = card;
    }, 0);
  },
  methods: {
    finish() {
      this.error = "";
      this.stripe.createToken(this.card).then(result => {
        if (result.error) {
          this.error = result.error.message;
        } else {
          this.$emit("token", result);
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.client-payment-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 465px;
  .cancel {
    font-size: 10px;
    text-align: right;
  }
  .align-center {
    justify-content: center;
    display: flex;
    flex-direction: column;
    height: 465px;
  }
  .full-width {
    width: 100%;
  }
  .small-top {
    margin-top: 10px;
  }
  .payment-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .StripeElement {
    background-color: white;
    height: 40px;
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid transparent;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }
  
  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }
  
  .StripeElement--invalid {
    border-color: #fa755a;
  }
  
  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
    .row-space-between {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

}
</style>
